<div class="expandContainer">
  <div class="expandItem size_{{item?.gridWidth}}" [attr.data-oddtype]="item?.oddTypeId" *ngFor="let item of allOdds; trackBy: trackByFn">
    <div class="itemHeader">{{item?.headerText?.split('|')[1]}}</div>


    <div class="outsideTexts padding_{{item.col}}" *ngIf="item.textLocation === 'outside'">
      <p *ngFor="let item of item.specialText">{{item}}</p>
    </div>
    <div class="oddContainer oddGroup vertical heightZero"
         *ngFor="let oddGroup of item.oddList">
      <ng-container *ngFor="let oddRow of oddGroup.rows">

        <oddView *ngIf="oddRow.length != 0"
                 [typeOfList]=typeOfList
                 [_data]="oddRow"
                 [oddNumber]="3"
                 [matchID]="item.matchID"
                 [specialValShow]="true"
                 [isWrapped]="true"
                 [isDoubleRow]="oddGroup.isDoubleRow"
                 [isDoubleWrap]="item.gridWidth >1"
                 [isExpandView]="true"
                 [fixtureItem]="fixtureItem"
        ></oddView>
      </ng-container>
    </div>


    <div class="oddContainer oddGroup secondLine vertical heightZero"
         *ngFor="let appendOddGroup of item.appendOddList">
      <ng-container *ngFor="let appendOddRow of appendOddGroup.rows">
        <oddView
          *ngIf="appendOddRow.length != 0"
          [typeOfList]=typeOfList
          [_data]="appendOddRow"
          [oddNumber]="3"
          [matchID]="item.matchID"
          [specialValShow]="true"
          [isWrapped]="true"
          [isDoubleRow]="appendOddGroup.isDoubleRow"
          [isDoubleWrap]="item.gridWidth >1"
          [isExpandView]="true"
          [isAppend]="appendOddGroup.isAppend"
          [fixtureItem]="fixtureItem"
          [isSecondHalf]="appendOddGroup.isSecondHalf"
        ></oddView>
      </ng-container>
    </div>

  </div>
</div>
